/* ==========================================================
   יישור טקסט לימין (עברית) – ערכת ClaudeCodeEdit
   ----------------------------------------------------------
   שפת הבסיס של החנות היא אנגלית, ולכן הערכה מציירת את העמוד
   משמאל לימין. הסקריפט עובר על אלמנטים שמכילים טקסט, וכל מה
   שמיושר לשמאל (left / start) מקבל יישור לימין. טקסט ממורכז
   (center) או מיושר לשני הצדדים (justify) לא נוגע.
   עוקב גם אחרי תוכן שנטען אחר כך (מגירת עגלה, פופאפים וכו').
   הכללים המשלימים (כיוון rtl לפסקאות וכותרות) נמצאים
   ב-assets/claude-theme-fixes.css, סעיף 7.
   ========================================================== */
(function () {
  'use strict';

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, svg: 1, SVG: 1, PATH: 1, IMG: 1, VIDEO: 1, IFRAME: 1, BR: 1, TEMPLATE: 1 };

  function hasOwnText(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.trim()) return true;
    }
    return false;
  }

  function fixElement(el) {
    if (SKIP[el.tagName] || !hasOwnText(el)) return;
    var cs = getComputedStyle(el);
    var align = cs.textAlign;
    if (align === 'left' || (align === 'start' && cs.direction === 'ltr') || (align === '-webkit-left')) {
      el.style.setProperty('text-align', 'right', 'important');
    }
  }

  function fixTree(root) {
    if (!root || root.nodeType !== 1) return;
    fixElement(root);
    var all = root.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) fixElement(all[i]);
  }

  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var list = pending;
    pending = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].isConnected) fixTree(list[i]);
    }
  }

  function init() {
    fixTree(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            pending.push(n.nodeType === 3 ? n.parentElement : n);
          }
        } else if (m.type === 'characterData' && m.target.parentElement) {
          pending.push(m.target.parentElement);
        }
      }
      if (pending.length && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
